import { createSlice } from "@reduxjs/toolkit";
import { toast } from 'react-toastify';
import { ApiStatus } from "../../utils/api.types";
import { fetchCurrencies } from "./currencyThunk";
import { ICurrencySliceState } from "../../utils/currency.types";

/**
 * Currency slice initial state.
 */
const initialState: ICurrencySliceState = {
    currencies: [],
    status: ApiStatus.IDLE,
    errorMessage: ''
}

/**
 * Currency Slice.
 */
const currencySlice = createSlice({
    name: 'currency',
    initialState: initialState,
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            // Fetch currencies
            .addCase(fetchCurrencies.pending, (state, action) => {
                state.status = ApiStatus.LOADING;
            })
            .addCase(fetchCurrencies.fulfilled, (state, action) => {
                state.status = ApiStatus.SUCCESS;
                state.currencies = action.payload || [];
                state.errorMessage = '';
            })
            .addCase(fetchCurrencies.rejected, (state, action) => {
                state.status = ApiStatus.FAILED;
                state.errorMessage = action.error.message
            })

            
    }
});

export default currencySlice.reducer;
